export default __webpack_public_path__ + "static/media/red5en.22b862cd.jpg";